<template>
  <div class="hm-card" :class="($template === 'article') ? 'article' : 'small'">
    <div class="max-w">
      <h2>Could You Save on Rx Costs with Medicare Extra Help?</h2>
      <img v-if="($template === 'article')" :class="{ 'article': ($template === 'article') }" src="//hm-lis.herokuapp.com/img/svg/LIS-Drug-Savings.svg" alt="image" class="score-banner">
      <p><strong>Over 50% of those who apply are approved!</strong></p>
      <p>Pay as little as $1.25 for generics and $3.80 for brand-name drugs.*</p>
      <br>
      <SuiButton color="green" :class="{ 'article': ($template === 'article') }" content="See if I qualify!" @click="() => goNextStep('medicaid')"/>
    </div>
  </div>
</template>

<script>
  import {Button} from 'semantic-ui-vue/dist/commonjs/elements/Button';

  export default {
    name: 'Start',
    components: {
      SuiButton: Button,
    },
    methods: {
      goNextStep(step) {
        this.$store.commit('setStep', step);
        if (this.$template == 'landing') {
          window.scrollTo(0,0);
        }
      },
    },
  }
</script>

<style lang="scss" scoped>

  button.green {
    padding: 1.25em;
    &.article {
      padding: 1em;
    }
  }

</style>
